function getIsSCFJourneyEnabled(configuration) {
  return configuration.app?.solJourney?.scfJourney?.enabled;
}

module.exports = { getIsSCFJourneyEnabled };
